export const CONFIG = {
    // Автоматически определяет, где запущен фронтенд
    API_URL: '',
    PHONE: '+7 (925) 143-12-99',
    PHONE_RAW: '+79251431299',
    SOCIALS: {
        VK: 'https://vk.com/club220051052',
        TG: 'https://t.me/kopstro',
        YANDEX: '#',
        AVITO: 'https://www.avito.ru/brands/6402b21ca442ea7955dc837aec0b47d6'
    }
};
